/* @flow */
/* eslint-disable camelcase */
/* eslint-disable babel/no-invalid-this */
import type { DimmerFeature } from "./types";

export default function Dimmer(feature: DimmerFeature) {
  let setLevelAction = feature.actions.set_level;

  this.setDimmerLevel = (level) => {
    if (setLevelAction == null) {
      return Promise.reject(
        new Error("Attempted to set level on a dimmer with no set level action")
      );
    }
    return this.executeDeviceAction(setLevelAction, { value: level });
  };

  return {
    status: `Level: ${feature.level}%`,
    dimmer_level: feature.level,
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/dimmer.js